<template>
  <base-layout>
    <RoleAddEdit
      :es-id="addEdit.esId"
      :stepper-mode="addEdit.stepperMode"
      :stepper-step="addEdit.stepperStep"
      :raw-data="addEdit.rawData"
      :busy="addEdit.busy"
      @refresh="$store.dispatch('fsTable/fetchData')"
    />
    <content-section :spacing="false">
      <div class="px-4 content-spacing">
        <title-plus
          :title="$t('components.rolesManagement.headline')"
          @plus="onOpenES({ primaryKey: null })"
          class="mb-10"
        />
      </div>
      <template>
        <FSTable
          :fst-id="fstId"
          :endpoint="indexDataEndpoint"
          :headers="getTableHeaders"
        >
          <template #default="{ data }">
            <template v-for="(item, itemIndex) in data">
              <template v-if="getTableMode === 'full'">
                <FSTableRow :key="itemIndex" textFallbackAlways>
                  <FSTableRowItem>
                    <p
                      class="text-blue-500 cursor-pointer"
                      @click.prevent="onOpenES({ primaryKey: item.id })"
                    >
                      {{ item.role_name }}
                    </p>
                  </FSTableRowItem>
                  <FSTableRowItem>
                    {{ item.created_by ? item.created_by.full_name : '--' }}
                    -
                    {{ item.created_by ? item.created_by.role_name : '--' }}
                  </FSTableRowItem>
                  <FSTableRowItem>
                    {{
                      getFormattedDateTime(
                        item.created_at,
                        'D MMM YYYY, h:mm:ss a'
                      )
                    }}
                  </FSTableRowItem>
                  <FSTableRowItem>
                    <div class="flex items-center">
                      <oto-edit-icon
                        @click="onOpenES({ primaryKey: item.id })"
                      />
                    </div>
                  </FSTableRowItem>
                </FSTableRow>
              </template>
              <template v-if="getTableMode === 'responsive'">
                <FSTableRow
                  :key="`fs-table-row-${itemIndex}`"
                  textFallbackAlways
                >
                  <FSTableRowItem>
                    <div
                      class="col-span-1 focus:text-gray-400"
                      @click="toggle(itemIndex)"
                    >
                      <i
                        class="fas fa-minus-circle"
                        style="color:#d90a20;"
                        v-if="opened.includes(itemIndex)"
                      ></i>
                      <i class="fas fa-plus-circle" v-else></i>
                    </div>
                  </FSTableRowItem>
                  <FSTableRowItem>
                    <p
                      class="text-blue-500 cursor-pointer"
                      @click.prevent="onOpenES({ primaryKey: item.id })"
                    >
                      {{ item.role_name }}
                    </p>
                  </FSTableRowItem>
                  <FSTableRowItem>
                    {{ item.created_by ? item.created_by.full_name : '--' }}
                    -
                    {{ item.created_by ? item.created_by.role_name : '--' }}
                  </FSTableRowItem>
                  <FSTableRowItem>
                    <div class="flex items-center">
                      <oto-edit-icon
                        @click="onOpenES({ primaryKey: item.id })"
                      />
                    </div>
                  </FSTableRowItem>
                </FSTableRow>
                <FSTableRow v-if="opened.includes(itemIndex)" :key="itemIndex">
                  <td colspan="10">
                    <div
                      class="grid grid-cols-10 items-center w-full expand-item"
                    >
                      <div class="col-span-5 left-text">
                        {{
                          $t(
                            'components.rolesManagement.table.columns.createdAt'
                          )
                        }}
                      </div>
                      <div class="col-span-5 right-text">
                        {{
                          getFormattedDateTime(
                            item.created_at,
                            'D MMM YYYY, h:mm:ss a'
                          )
                        }}
                      </div>
                    </div>
                  </td>
                </FSTableRow>
              </template>
            </template>
          </template>
        </FSTable>
      </template>
    </content-section>
  </base-layout>
</template>

<script>
import BaseLayout from '@/views/shared/BaseLayout.vue'
import ContentSection from '@/components/layout/ContentSection'
import TitlePlus from '@/components/ui/TitlePlus'
import OtoEditIcon from '@/components/ui/OtoEditIcon'
import { getFormattedDateTime } from '@/utils/datetime'
import RoleAddEdit from '@/views/acl/role-add-edit/RoleAddEdit.vue'
import { FSTable, FSTableRow, FSTableRowItem } from '@/components/fs-table'
import { RoleConfig } from '@/config/RoleConfig'
import { useEndpoints } from '@/composables'
export default {
  name: 'Roles',
  components: {
    BaseLayout,
    ContentSection,
    OtoEditIcon,
    TitlePlus,
    FSTable,
    FSTableRow,
    FSTableRowItem,
    RoleAddEdit,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      opened: [],
      fstId: 'RolesIndex',
      indexDataEndpoint: useEndpoints.role.index(),
      tableHeaders: [
        {
          text: `${this.$t('components.rolesManagement.table.columns.Name')}`,
          width: '15%',
          sort: null,
        },
        {
          text: `${this.$t(
            'components.rolesManagement.table.columns.createdBy'
          )}`,
          width: '25%',
          sort: null,
        },
        {
          text: `${this.$t(
            'components.rolesManagement.table.columns.createdAt'
          )}`,
          width: '25%',
          sort: null,
        },
        {
          text: `${this.$t(
            'components.rolesManagement.table.columns.actions'
          )}`,
          width: '20%',
          sort: null,
        },
      ],
      resTableHeaders: [
        { text: '', width: '10%', sort: null },
        {
          text: `${this.$t('components.rolesManagement.table.columns.Name')}`,
          width: '30%',
          sort: null,
        },
        {
          text: `${this.$t(
            'components.rolesManagement.table.columns.createdBy'
          )}`,
          width: '30%',
          sort: null,
        },
        {
          text: `${this.$t(
            'components.rolesManagement.table.columns.actions'
          )}`,
          width: '30%',
          sort: null,
        },
      ],
      addEdit: {
        // EdgeStack component
        esId: 'role-add-edit',

        // XStepper component
        stepperMode: 'strict',
        stepperStep: 1,

        // Data
        busy: true,
        rawData: null,
        primaryKey: null,
      },
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    getTableHeaders() {
      if (this.windowWidth <= 930) {
        return this.resTableHeaders
      } else {
        return this.tableHeaders
      }
    },
    getTableMode() {
      if (this.windowWidth <= 930) {
        return 'responsive'
      } else {
        return 'full'
      }
    },
  },
  methods: {
    getFormattedDateTime,
    onResize() {
      this.windowWidth = window.innerWidth
    },
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    async onOpenES({ primaryKey }) {
      if (typeof primaryKey === 'number') {
        this.addEdit.busy = true
        this.$edgeStack.open(this.addEdit.esId)
        const vReq = this.$http.get(RoleConfig.api.detail(primaryKey))

        const requests = [vReq]

        await this.$http
          .all(requests)
          .then(
            this.$http.spread((...responses) => {
              let data = {}
              const [rRes] = responses
              console.log(rRes.data, 'vRes')

              data = { ...rRes.data }

              this.addEdit.stepperMode = 'free'

              this.addEdit.busy = false
              this.addEdit.rawData = data
            })
          )
          .catch((err) => {
            console.warn({ err })

            this.$edgeStack.close(this.addEdit.esId)
            this.$notify({
              group: 'bottomRight',
              type: 'error',
              title: `Server Error`,
              text: 'Failed to retrieve data. Please try again.',
            })
          })

        return
      }

      this.addEdit.stepperMode = 'strict'

      this.addEdit.busy = false
      this.addEdit.rawData = null
      this.addEdit.primaryKey = null

      this.$edgeStack.open(this.addEdit.esId)
    },
  },
}
</script>

<style lang="scss" scoped>
.left-text {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3a4048;
}
.right-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6d6d75;
}
</style>
